import {FC, useState} from 'react'
import ShippingMethodsDialog from './ShippingMethodsDialog'
import {useDispatch} from 'react-redux'
import {showMessage} from 'app/redux/messageSlice'
import CustomRateButton from './CustomRateButton'
import FreeShipping from './FreeShipping'

interface FreeShipProps {
  freeShipCode?: string
  freeShippingDiscountCodeId: string
  isFreeShipping: boolean
  onRemoveDiscount: () => void
}

interface ShippingRate {
  id: string | any
}

interface Props {
  shippingPrice: number | any
  onFetch: () => any
  onShippingMethodChange: (shippingMethod: any) => void
  selectedRateId?: string
  freeShipping?: FreeShipProps
  disabled?: boolean
  title: string
  children?: React.ReactNode
  customRateDialog: any
  onCustomRateOpen: (val: any) => void
  showCustomRate: boolean
  orderSuggestion?: React.ReactNode
  showModal: boolean
  onSetShowModal: (val: any) => void
  shippingRate: ShippingRate | any
}

const ShippingRates: FC<Props> = ({
  shippingPrice,
  onFetch,
  onShippingMethodChange,
  selectedRateId,
  freeShipping,
  disabled,
  title = 'Shipping',
  children,
  customRateDialog,
  onCustomRateOpen,
  showCustomRate,
  orderSuggestion,
  showModal,
  onSetShowModal,
  shippingRate,
}) => {
  const dispatch = useDispatch()
  const [shippingMethods, setShippingMethods] = useState<any[]>([])
  const [isFetching, setIsFetching] = useState(false)

  const handleClose = () => {
    onSetShowModal(false)
  }

  const handleShipping = async () => {
    try {
      setIsFetching(true)
      const methods = await onFetch()
      onSetShowModal(true)
      setShippingMethods(methods)
    } catch (err) {
      console.error(err)
      dispatch(
        showMessage({text: 'Error occurred while getting shipping methods', variant: 'error'})
      )
    } finally {
      setIsFetching(false)
    }
  }

  const handleSelectShippingMethod = (shippingMethod: any) => {
    onShippingMethodChange({
      ...shippingMethod,
      title: shippingMethod.serviceName,
      serviceId: shippingMethod.rateClassId,
    })
  }

  const handleShowDialog = () => {
    onCustomRateOpen(true)
  }

  if (freeShipping && freeShipping.isFreeShipping) {
    return <FreeShipping {...freeShipping} />
  }

  if (showCustomRate && customRateDialog) {
    return customRateDialog
  }

  return (
    <>
      <div>
        <button
          id='btnAddShipping'
          className='btn btn-link p-0 bg-transparent text-primary-active fw-bolder'
          data-bs-toggle='tooltip'
          data-bs-trigger='hover'
          title=''
          onClick={handleShipping}
          disabled={disabled}
        >
          {shippingPrice > 0 || shippingRate?.id ? title : 'Add'}
        </button>
        {isFetching && (
          <label>
            <span className='indicator-progress d-block'>
              <span className='spinner-border spinner-border-sm  ms-2 mt-3 align-middle text-info'></span>
            </span>
          </label>
        )}
      </div>

      {showModal && (
        <>
          <ShippingMethodsDialog
            selectedRateId={selectedRateId}
            onClose={handleClose}
            isFetching={isFetching}
            shippingMethods={shippingMethods}
            onShippingMethodChange={handleSelectShippingMethod}
            customRate={
              <>
                <CustomRateButton onClick={handleShowDialog} />
                {orderSuggestion}
              </>
            }
          >
            {children}
          </ShippingMethodsDialog>
        </>
      )}
    </>
  )
}

export default ShippingRates
